import { message } from "antd";
import ConsultationService from "../../Services/ConsultationService";

export const onMedicineOrderSend = async (
  appointmentDetails,
  pharmacyDetails,
  medicineList,
  consultationId,
) => {
  if (!consultationId) {
    return;
  }
  if (medicineList.length == 0) {
    return;
  }
  let LinkPayload = {
    consultationId: consultationId,
    patientId: appointmentDetails?.patientId,
    userId: appointmentDetails?.userId,
    appointmentId: appointmentDetails?.appointmentId,
    prescriptionShareType: "p",
    vendorId: pharmacyDetails?.pharmacyId,
    vendorName: pharmacyDetails?.pharmacyName,
    vendorMailId: pharmacyDetails?.pharmacyMailId,
    vendorMobile: pharmacyDetails?.pharmacyMobile,
    drugPrescriptionStatus: "Sent",
    rejectedPharmacyRemarks: null,
    account_Id: appointmentDetails?.account_Id,
    clinic_id: appointmentDetails?.clinic_Id,
    sourceChannel: "DOCTOR",
  };

  try {
    const response = await ConsultationService.SharePharmaLabAPI(LinkPayload);

    if (response.data.message !== "Prescription sent successfully") {
      message.error("Medicine order is already placed");
      return;
    }
    message.success(`Medicine Order Sent to ${LinkPayload.vendorName}`);
  } catch (error) {
    message.error("An error occured while sending Orders");
  }
};

export const onLabOrderSend = async (
  appointmentDetails,
  labDetails,
  consultationId,
) => {
  if (!consultationId) {
    return;
  }

  let LinkPayload = {
    consultationId: consultationId,
    patientId: appointmentDetails?.patientId,
    userId: appointmentDetails?.userId,
    appointmentId: appointmentDetails?.appointmentId,
    prescriptionShareType: "l",
    vendorId: labDetails?.labId,
    vendorName: labDetails?.labName,
    vendorMailId: labDetails?.labMailId,
    vendorMobile: labDetails?.labMobile,
    labPrescriptionStatus: "Sent",
    rejectedLabRemarks: null,
    account_Id: appointmentDetails?.account_Id,
    clinic_id: appointmentDetails?.clinic_Id,
    sourceChannel: "DOCTOR",
  };

  try {
    const response = await ConsultationService.SharePharmaLabAPI(LinkPayload);

    if (response.data.message !== "Prescription sent successfully") {
      message.error("Lab order is already placed");
      return;
    }
    message.success(`Lab Order Sent to ${LinkPayload.vendorName}`);
  } catch (error) {
    message.error("Lab order is already placed");
  }
};
